import React from "react"
import styled from "styled-components"
import { StaticGoogleMap, Marker } from "react-static-google-map"


const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

export default ({ branch, width, height }) => {
  return (
    branch && (
      <LocationContainer>
        {branch.lat && branch.lng && (
          <div >
            <StaticGoogleMap
              size={`${width}x${height}`}
              className="img-fluid"
              apiKey="AIzaSyDC-P1JcJevKOnR6kAEntnzXGIn4ClTQgg"
            >
              <Marker
                location={`${branch.lat}, ${branch.lng}`}
                color="red"
                label="A"
              />
            </StaticGoogleMap>
          </div>
        )}
      </LocationContainer>
    )
  )
}
